import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class EmployeeDepositsService {

  readonly rootUrl = AppSettings.webApiURL;;
  constructor(public httpClient: HttpClient) { }

  getDate(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetDate?customerId=${customerId}`);
  }
  getEmp(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetEmployee?customerId=${customerId}`);
  }
  getFeedbackStatusDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetAllFeedbackStatus`);
  }
  getReport(fromDate, toDate, FileEmployeeId, selectedStatusId, customerId, selectedFundInstitutionId, ReportType, dateType, includeFurlough) {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetReport?fromDate=${fromDate}&toDate=${toDate}&empId=${FileEmployeeId}&selectId=${selectedStatusId}&customerId=${customerId}&fundInstitutionId=${selectedFundInstitutionId}&ReportType=${ReportType}&dateType=${dateType}&includeFurlough=${includeFurlough}`);
  }
  getCustomers() {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetCustomers`);
  }
  getFundInstitution(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/EmployeeDepositApi/GetFundInstitution?customerId=${customerId}`);
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/employee-deposits.service.ts